var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectedAccIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45256 17.5966L9.50506 17.5441C8.56899 18.4765 7.30163 19 5.98045 19C4.65927 19 3.39192 18.4765 2.45585 17.5441C1.52349 16.6081 1 15.3407 1 14.0195C1 12.6984 1.52349 11.431 2.45585 10.4949L4.51062 8.44018M10.5474 2.40336L10.4949 2.45585C11.431 1.52349 12.6984 1 14.0195 1C15.3407 1 16.6081 1.52349 17.5441 2.45585C18.4765 3.39192 19 4.65927 19 5.98045C19 7.30163 18.4765 8.56899 17.5441 9.50506L15.4894 11.5598M13.6596 18.699L6.34041 1.30098",
    stroke: "#39848A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectedAccIcon);
export default __webpack_public_path__ + "static/media/connected_acc_icon.e3ee8fe5307531a3bae30da17ce69a55.svg";
export { ForwardRef as ReactComponent };